import { render, staticRenderFns } from "./ScatterGraph.vue?vue&type=template&id=3c15bd82"
import script from "./ScatterGraph.vue?vue&type=script&lang=ts"
export * from "./ScatterGraph.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports